import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useSearcherTabs from "../../hooks/useSearcherTabs.js";
import { getTransformedPropsIfNeededMobile } from "../../utils/model.js";
import * as S from "./styled.js";
const MobileSearcherTabs = (rootProps)=>{
    const props = 'data' in rootProps ? rootProps.data : rootProps.props;
    const transformedProps = getTransformedPropsIfNeededMobile(props);
    const { title ='' , variant  } = transformedProps ?? {};
    const { finalTabs , sliderProps , selectedTab , setSelectedTab  } = useSearcherTabs(transformedProps);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "SearcherTabs",
        children: [
            title && /*#__PURE__*/ _jsx(S.SearcherTabsTitle, {
                children: title
            }),
            /*#__PURE__*/ _jsx(S.SearcherTabsTabsMobile, {
                tabs: finalTabs,
                selectedTab: selectedTab,
                onClick: setSelectedTab,
                sliderProps: sliderProps,
                $variant: variant,
                showOnlyOneTab: false
            })
        ]
    });
};
export default MobileSearcherTabs;

//# sourceMappingURL=index.js.map